import { cn } from "@/lib/utils";

interface ConnectorsEmptyProps {
  className?: string;
}

export function ConnectorsEmpty({ className }: ConnectorsEmptyProps) {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <rect
        x="30"
        y="44"
        width="60"
        height="36"
        style={{ fill: "hsl(var(--muted))", stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <ellipse
        cx="60"
        cy="44"
        rx="30"
        ry="9"
        style={{ fill: "hsl(var(--muted))", stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <ellipse
        cx="60"
        cy="80"
        rx="30"
        ry="9"
        style={{ fill: "hsl(var(--muted))", stroke: "hsl(var(--border))" }}
        strokeWidth="1.5"
      />
      <rect
        x="50"
        y="56"
        width="20"
        height="16"
        rx="2"
        style={{
          fill: "hsl(var(--primary) / 0.2)",
          stroke: "hsl(var(--primary))",
        }}
        strokeWidth="1.5"
      />
      <path
        d="M55 56 Q55 49 60 49 Q65 49 65 56"
        style={{ stroke: "hsl(var(--primary))" }}
        strokeWidth="1.5"
        fill="none"
        strokeLinecap="round"
      />
      <circle
        cx="60"
        cy="64"
        r="2.5"
        style={{ fill: "hsl(var(--primary))" }}
      />
    </svg>
  );
}
